import { Mutation } from 'vuex'
import { ArticleState } from '../types'

const setArticleFieldsLoading: Mutation<ArticleState> = (state, payload) => {
  state.isLoadingFields = payload
}

export default setArticleFieldsLoading
